import { render, staticRenderFns } from "./page-foot-title.vue?vue&type=template&id=aabfbfde&"
import script from "./page-foot-title.vue?vue&type=script&lang=js&"
export * from "./page-foot-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports